<template>
    <span class="data-value copy-element">
        <CompassLink :label="phoneNumber" :link="formattedPhoneNumberLink">
            {{ phoneNumber }}
        </CompassLink>
        <SaasClipboard v-if="phoneNumber" :data="phoneNumber" />
    </span>
</template>

<script>
import SaasClipboard from 'vcomponents/utilities/SaasClipboard.vue';
import { createNamespacedHelpers } from 'vuex';
const { mapState } = createNamespacedHelpers('corp');

export default {
    components: {
        SaasClipboard,
    },
    props: {
        phoneNumber: {
            type: String,
            default: '',
        },
    },
    computed: {
        ...mapState(['phonecallProtocol']),
        formattedPhoneNumberLink() {
            return `${this.phonecallProtocol}:${this.trimLink(this.phoneNumber)}`;
        },
    },
    methods: {
        trimLink(link) {
            return link.replaceAll(' ', '');
        },
    },
};
</script>
